import { styled } from '@mui/material/styles';
import { Dialog, Box, Typography, Button } from '@mui/material';

export const StyledDialog = styled(Dialog)({
  '& .MuiDialog-paper': {
    width: '700px',
    maxWidth: 'none',
    overflow: 'hidden',
    borderRadius: '16px',
    maxHeight: 'none',
  },
});

export const DialogHeaderBox = styled(Box)({
  padding: '24px 32px 20px 32px',
  borderBottom: '1px solid var(--border)',
});

export const DialogTitleTypography = styled(Typography)({
  fontFamily: 'Lufga',
  fontWeight: 600,
  fontSize: '20px',
  color: 'var(--primary-navy)',
  marginBottom: '4px',
});

export const DialogSubtitleTypography = styled(Typography)({
  fontFamily: 'Outfit',
  fontWeight: 400,
  fontSize: '14px',
  color: 'var(--subtext)',
});

export const CloseIconBox = styled(Box)({
  position: 'absolute',
  top: 24,
  right: 32,
  fontSize: '24px',
  cursor: 'pointer',
  color: 'var(--instructions)',
  '&:hover': {
    color: 'var(--error)',
  },
});

export const DialogContentBox = styled(Box)({
  padding: '24px 32px',
  overflow: 'visible',
});

export const FormFieldRow = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  gap: '20px',
  marginBottom: '0px',
});

export const FormFieldColumn = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
});

export const DialogActionsBox = styled(Box)({
  display: 'flex',
  justifyContent: 'flex-start',
  padding: '20px 32px 32px 32px',
  gap: '12px',
});

export const SubmitButton = styled(Button)({
  fontFamily: 'Outfit',
  fontSize: '14px',
  fontWeight: 500,
  textTransform: 'none',
  color: 'var(--bg-color)',
  backgroundColor: 'var(--primary-blue)',
  border: '1px solid var(--border-blue)',
  borderRadius: '8px',
  padding: '8px 32px',
  '&:hover': {
    backgroundColor: 'var(--hover-blue)',
  },
  '&:disabled': {
    backgroundColor: 'var(--inactive-btn)',
    color: 'var(--instructions)',
    border: '1px solid var(--inactive-border)',
  },
});

export const CancelButton = styled(Button)({
  fontFamily: 'Outfit',
  fontSize: '14px',
  fontWeight: 500,
  textTransform: 'none',
  color: 'var(--instructions)',
  backgroundColor: 'var(--inactive-btn)',
  border: '1px solid var(--inactive-border)',
  borderRadius: '8px',
  padding: '6px 24px',
});
